(function($) {
  window.Edu = window.Edu || {};

  /**** Parse querystring for easy use in other javascript files ****/
  window.Edu.queryString = {};
  document.location.search.replace(/(^\?)/, '').split('&').map(function (keyValue) {
    keyValue = keyValue.split('=');
    if (keyValue[0] && keyValue[1]) {
      window.Edu.queryString[keyValue[0]] = keyValue[1];
    }
  });

  /**** Analytics Tracking ****/
  window.Edu.trackEvent = function(name, segment_data, ga_fields) {
    if(ga_fields && ga_fields.eventCategory && ga_fields.eventAction) {
      // GA
      (window.ga || function(){})('send','event',ga_fields);

      // GTM
      (window.dataLayer || []).push({
        event: 'GAEvent',
        eventCategory: ga_fields.eventCategory,
        eventAction: ga_fields.eventAction,
        eventLabel: ga_fields.eventLabel,
        eventValue: ga_fields.eventValue
      });
    }

    // Segment
    if(name && window.analytics && window.analytics.track) {
      // TODO: if we switch GA to segment, merge in ga fields
      window.analytics.track(name, segment_data);
    }
  };
  window.Edu.trackProductView = function(data) {
    var sku = data.sku;
    if(!sku) return;
    var name = data.name || sku;
    var category = data.category || null;
    var price = data.price || 0;

    // GA
    if(window.ga) {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:addProduct', {
        id: sku,
        name: name,
        category: category,
        brand: "Education.com",
        price: price
      });
      window.ga('ec:setAction', 'detail');
      window.ga('send', 'event', 'ecommerce', 'detail', sku, {'nonInteraction': 1});
    }

    // GTM
    (window.dataLayer || []).push({
      ecommerce: {
        detail: {
          actionField: { },
          products: [{
            id: sku,
            name: name,
            category: category,
            brand: "Education.com",
            price: price
          }]
        }
      }
    });
    (window.dataLayer || []).push({
      event: 'GAEvent',
      eventCategory: 'ecommerce',
      eventAction: 'detail',
      eventLabel: sku
    });

    // Segment
    if(window.analytics && window.analytics.track) {
      window.analytics.track('Viewed Product',{
        id: sku,
        sku: sku,
        name: name,
        price: price,
        category: category
      });
    }
  };
  window.Edu.setCheckoutStepInfo = function(data) {
    var sku = data.sku;
    if(!sku) return;
    var name = data.name || sku;
    var category = data.category || null;
    var price = data.price || 0;
    var step_data = step_data || {};

    // GA
    if(window.ga) {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:addProduct', {
        id: sku,
        name: name,
        category: category,
        brand: "Education.com",
        price: price,
        quantity: 1
      });
      window.ga('ec:setAction', 'checkout', step_data);
    }

    // GTM
    (window.dataLayer || []).push({
      event: 'checkout',
      ecommerce: {
        checkout: {
          actionField: step_data,
          products: [{
            id: sku,
            name: name,
            category: category,
            brand: "Education.com",
            price: price,
            quantity: 1
          }]
        }
      }
    });
  };
  window.Edu.trackPurchase = function(data) {
    if(!data.sku || !data.orderId) return;

    var sku = data.sku;
    var name = data.name || sku;
    var price = (data.price || 0)*1;
    var category = data.category || null;
    var orderId = data.orderId;
    var discount = (data.discount || 0)*1;
    var ltv = (data.ltv || (price - discount))*1;
    var coupon = data.coupon || "";
    var currency = data.currency || "USD";
    var revenue = (price - discount)*1;

    // GA
    if(window.ga) {
      window.ga('require', 'ec', 'ec.js');
      window.ga('ec:addProduct', {
        id: sku,
        name: name,
        category: category,
        brand: "Education.com",
        price: revenue.toFixed(2),
        coupon: coupon,
        quantity: 1
      });
      window.ga('ec:setAction', 'purchase', {
        id: orderId,
        revenue: revenue.toFixed(2),
        coupon: coupon
      });
      window.ga('send', 'event', 'ecommerce', 'purchase', sku, Math.round(ltv), {'nonInteraction': 1});
    }

    // GTM
    (window.dataLayer || []).push({
      ecommerce: {
        purchase: {
          actionField: {
            id: orderId,
            revenue: revenue.toFixed(2),
            coupon: coupon
          },
          products: [{
            id: sku,
            name: name,
            category: category,
            brand: "Education.com",
            price: revenue.toFixed(2),
            coupon: coupon,
            quantity: 1
          }]
        }
      }
    });
    (window.dataLayer || []).push({
      event: 'GAEvent',
      eventCategory: 'ecommerce',
      eventAction: 'purchase',
      eventContentType: category,
      eventContentIds: "'" + sku + "'",
      eventLabel: sku,
      eventValue: Math.round(ltv),
      eventOrderId: orderId,
      eventCurrency: currency,
      eventCoupon: coupon,
      eventPrice: revenue
    });

    // Segment
    if(window.analytics && window.analytics.track) {
      window.analytics.track('Completed Order',{
        orderId: orderId,
        total: price,
        revenue: revenue,
        ltv: ltv,
        shipping: 0,
        tax: 0,
        discount: discount,
        coupon: coupon,
        currency: currency,
        products: [
          {
            id: sku,
            sku: sku,
            name: name,
            price: price,
            category: category,
            quantity: 1
          }
        ]
      });
    }
  };

    /**** Dispatch events that React components can listen to ****/
    window.Edu.reactDispatch = function(eventName, data) {
        eventName = 'edureact_'+eventName;

        var event;
        try {
            event = new CustomEvent(eventName, {detail: data});
        }
        catch(e) {
            // IE doesn't support CustomEvent as a constructor, so need to use this legacy method as a fallback
            event = document.createEvent('CustomEvent');
            event.initCustomEvent(
                event,
                false,
                true,
                data
            );
        }

        document.dispatchEvent(event);
    };

  /**** Pop-up Modals ****/
  $.fn.modal = function(options) {
    // Instantiation
    if(!this.data('modal')) {
      var self = this;
      options = options || {};
      this.data('modal',options);
      options.el = self;

      options.show = function() {
        // Close all open modals
        $('.modal.open').removeClass('open');

        // Don't allow closing a modal until it's finished opening
        // This solves the issue of a double-click opening and then immediately closing the modal
        window.clearTimeout(window.Edu.modal_open_timer);
        window.Edu.modal_open_timer = window.setTimeout(function() {
          window.Edu.modal_open_timer = 0;

          // If this is mobile, don't auto-focus an input (causes keyboard to popup)
          if(navigator.userAgent.match(/(Mobile|Tablet)/i)) {
            return;
          }

          //Focus on the first empty input.
          var numberOfInputFieldsToCheck = 2;
          var focusedInput = false;
          var inputElements = $('input[type=text]:visible, input[type=email]:visible, ' +
          'input[type=password]:visible', self);

          for (var i = 0; i < inputElements.length; i++) {
            if (i < numberOfInputFieldsToCheck && !$(inputElements[i]).val()) {
              $(inputElements[i]).focus();
              focusedInput = true;
              break;
            }
          }

          //If all inputs are filled, focus on the first one.
          if (!focusedInput) {
            $(inputElements[0]).focus();
          }
        },500);

        // Show modal
        window.Edu.overlay && window.Edu.overlay.fadeIn(500);
        self.addClass('open');

        if(this.onOpen) this.onOpen.call(this, arguments);
      };
      options.hide = function() {
        // Close all modals and hide overlay
        $('body').css('overflow', 'visible');
        $('.modal.open').removeClass('open');
        window.Edu.overlay && window.Edu.overlay.fadeOut(500);
        if(this.onClose) this.onClose.call(this);
      };

      options.disabled = options.disabled || false;
      options.showOverlay = options.showOverlay || function () {
        options.el.addClass('has_overlay');
        options.disabled = true;
        $('.icon-cancel, .icon-cancel-light, .close', options.el).hide();
      };
      options.hideOverlay = options.hideOverlay || function () {
        options.el.removeClass('has_overlay');
        options.disabled = false;
        $('.icon-cancel, .icon-cancel-light, .close', options.el).show();
      };

      // Close icon and links
      $('.icon-cancel, .icon-cancel-light, .close',this).on('click',function() {
        options.hide();
        $(document).trigger('modalClosed');
        return false;
      });
      // Close when the space below the modal is clicked
      this.on('click',function(e) {
        if(e.target && $(e.target).hasClass('modal')) {
          options.hide();
        }
      });
      // Listen for form submits
      if(options.submit) {
        $('form',this).on('submit',function(e) {
          e.preventDefault();
          self.modal('submit');
        });
      }
      // Show modal when trigger is clicked
      if(options.trigger) {
        options.trigger.on('click',function() {
          options.show();
          return false;
        });
      }

      // Initialization
      if(options.init) options.init();
    }
    else {
      // Call method
      var data = this.data('modal');
      if(data[options] && $.isFunction(data[options])) {
        var result = data[options].apply(data,Array.prototype.slice.call(arguments,1));
        if(result!==undefined) return result;
      }
      // Unknown
      else {
        console.error("Trying to call unknown modal method",options);
      }
    }

    return this;
  };
  window.Edu.createModal = function(html, options) {
    var container = $("<div class='modal'></div>").appendTo($(document.body));
    container.append('<i class="icon-cancel"></i>');
    $("<div class='modal-content'></div>").html(html).appendTo(container);
    container.modal(options);

    return container;
  };

  window.Edu.cache = {prefix:"educ-"};

  // API helper methods with runtime cache
  window.Edu.api = {
    invalidateStudentsCache: function() {
      if(!window.Edu.memberId) return;
      window.Edu.api._invalidate('api.getStudents.v1.'+window.Edu.memberId);
    },
    getStudents: function(callback, nocache) {
      return new Promise(function(resolve, reject) {
          var cb = function(err, resp) {
              if(callback) {
                  callback(err,resp);
              }

              if(err) reject(Error(err));
              else resolve(resp);
          };

          if(!window.Edu.memberId) {
              cb('No member id');
              return;
          }

          var cache_key = 'api.getStudents.v1.'+window.Edu.memberId;
          var api_process = function(resp) {
              return resp.children;
          };
          window.Edu.api._get(cache_key,'/api/children',{},api_process,cb,nocache);
      });
    },
    invalidateAllGroupsCache: function() {
        if(!window.Edu.memberId) return;
        window.Edu.api._invalidate('api.getAllGroups.v1.'+window.Edu.memberId);
    },
    getAllGroups: function(nocache) {
      return new Promise(function(resolve, reject) {
        var cb = function(err, resp) {
          if(err) reject(Error(err));
          else resolve(resp);
        };

        if(!window.Edu.memberId) {
          cb("No member id");
          return;
        }

        var cache_key = 'api.getAllGroups.v1.'+window.Edu.memberId;
        var api_process = function(resp) {
          return resp.groups;
        };
        window.Edu.api._get(cache_key,'/api/children/groups',{},api_process,cb,nocache);
      });
    },
    invalidateStudentGroupsCache: function() {
      if(!window.Edu.memberId) return;
      window.Edu.api._invalidate('api.getStudentGroups.v1.'+window.Edu.memberId);
    },
    getStudentGroups: function(callback, nocache) {
        return new Promise(function(resolve, reject) {
            var cb = function(err, resp) {
                if(callback) {
                    callback(err,resp);
                }

                if(err) reject(Error(err));
                else resolve(resp);
            };

            if(!window.Edu.memberId) {
                cb('No member id');
                return;
            }

            var cache_key = 'api.getStudentGroups.v1.'+window.Edu.memberId;
            var api_process = function(resp) {
                return resp.groups;
            };
            window.Edu.api._get(cache_key,'/api/children/groups',{},api_process,cb,nocache);
        });
    },
    invalidateAssignmentsCache: function() {
      if(!window.Edu.memberId) return;
      window.Edu.api._invalidate('api.getAssignments.v1.'+window.Edu.memberId);
    },
    invalidateSingleAssignmentCache: function(assignmentId) {
        if(!window.Edu.memberId) return;
        window.Edu.api._invalidate('api.getSingleAssignment.v1.'+ assignmentId);
    },
    getSingleAssignment: function(assignmentId, callback, nocache) {
        return new Promise(function(resolve, reject) {
            var cb = function(err, resp) {
                if(callback) {
                    callback(err,resp);
                }

                if(err) reject(Error(err));
                else resolve(resp);
            };

            if(!window.Edu.memberId) {
                cb('No member id');
                return;
            }

            if(!assignmentId) {
                cb('No assigmentId');
                return;
            }

            var cache_key = 'api.getSingleAssignment.v1.'+assignmentId;
            var url = '/api/assignments/'+assignmentId;
            var api_process = function(resp) {
              return resp;
            };
            window.Edu.api._get(cache_key,url,{},api_process,cb,nocache);
        });
    },
    getAssignmentsCacheKey: function() {
      return 'api.getAssignments.v1.' + window.Edu.memberId;
    },
    getAssignments: function(callback, nocache, getFullItemDetails) {
        return new Promise(function(resolve, reject) {
            var cb = function(err, resp) {
                if(callback) {
                    callback(err,resp);
                }

                if(err) reject(Error(err));
                else resolve(resp);
            };

            if(!window.Edu.memberId) {
                cb('No member id');
                return;
            }

            var cache_key = window.Edu.api.getAssignmentsCacheKey();
            var url = '/api/assignments/member/'+window.Edu.memberId;
            var data = {
                page:1,
                limit:100,
                sortType:'dateCreated',
                sortDirection:-1,
                getFullItemDetails: getFullItemDetails ? '1' : ''
            };
            var api_process = function(resp) {
                return resp.assignments;
            };
            window.Edu.api._get(cache_key,url,data,api_process,cb,nocache);
        });
    },
    _invalidate: function(cache_key) {
      if (!cache_key) return;

      // If we're currently fetching, no need to invalidate
      if(window.Edu.cache[cache_key] === 'fetching') {
        return;
      }

      // Invalidate runtime cache
      window.Edu.cache[cache_key] = null;

      // Invalidate local storage cache
      window.localStorage.removeItem(window.Edu.cache.prefix+cache_key);
    },
    _get: function(cache_key, url, data, api_process, callback, nocache) {
      if (cache_key) {
        // Runtime Cache
        if(!nocache && window.Edu.cache[cache_key]) {
            // Another process is currently fetching groups, try again in 200ms
            if(window.Edu.cache[cache_key] === 'fetching') {
                window.setTimeout(function() {
                    window.Edu.api._get(cache_key, url, data, api_process, callback, nocache);
                },200);
                return;
            }

            callback(null, window.Edu.cache[cache_key]);
            return;
        } else {
            window.Edu.cache[cache_key] = 'fetching';
        }
      }

      // Persistent cache disabled via querystring
      if(window.location.href.match(/\bnocache\b/)) {
        nocache = true;
      }

      // Local storage
      if(!nocache) {
        var cached = window.localStorage.getItem(window.Edu.cache.prefix+cache_key);
        if(cached) {
          var decoded = JSON.parse(cached);
          // Make sure cached data hasn't expired yet
          if(decoded && decoded.data && decoded.expires && decoded.expires > (new Date()).getTime()) {
            // Runtime cache
            window.Edu.cache[cache_key] = decoded.data;

            callback(null, window.Edu.cache[cache_key]);
            return;
          }
          else {
            // Either corrupted data or expired, remove from localstorage
            window.localStorage.removeItem(window.Edu.cache.prefix+cache_key);
          }
        }
      }

      // API
      $.get(url, data, function(results) {
        if(results) {
          // Process results into proper format for return
          if(api_process) {
            try {
              results = api_process(results);
            }
            catch(e) {
              callback(e);
              return;
            }
          }

          if (cache_key) {
            // Runtime cache
            window.Edu.cache[cache_key] = results;

            // Local storage cache
            try {
              window.localStorage.setItem(window.Edu.cache.prefix+cache_key, JSON.stringify({
                data: results,
                timeCached: ((new Date()).getTime())/1000,
                // Cache for 20 minutes
                expires: (new Date()).getTime() + 20*60*1000
              }));
            }
            catch(e) {}
          }
          callback(null, results);
        }
        else {
          callback('Failed to load '+cache_key);
        }
      }).fail(function() {
        callback('Failed to load '+cache_key);
      });
    }
  };

  /**** Lazy load content as it comes into view ****/
  var swapLazyloadSrc = function(el) {
    // Support IE11 which doesn't have built-in dataset support
    var dataset = el.dataset || $(el).data();

    if(dataset.lazyloadSrc) {
      el.src = dataset.lazyloadSrc;
    }
    if(dataset.lazyloadSrcset) {
      el.srcset = dataset.lazyloadSrcset;
    }
  };

  var observer = null;
  if(window.IntersectionObserver) {
    // Modern browsers can use a native api to determine when things come into view
    observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        // In viewport?
        if(entry.intersectionRatio > 0) {
          // Stop observing and load the image
          observer.unobserve(entry.target);

          swapLazyloadSrc(entry.target);
        }
      });
    },{rootMargin: '150px 0px', threshold: 0.01});
  }

  window.Edu.lazyload = function(el) {
    // Use the native IntersectionObserver when available
    if(observer) {
      observer.observe(el);
    }
    // Fallback to just loading the image immediately
    else {
      swapLazyloadSrc(el);
    }
  };

  $.fn.lazyload = function() {
    // This element is lazyloaded directly
    if(this.attr('data-lazyload-src') || this.attr('data-lazyload-srcset')) {
      window.Edu.lazyload(this[0]);
    }
    // This element's children should be lazy loaded
    else {
      $('[data-lazyload-src],[data-lazyload-srcset]', this).each(function() {
        window.Edu.lazyload(this);
      });
    }

    return this;
  };

  // Start lazy-loading in DOMContentReady
  $(document).ready(function() {
    $(document.body).lazyload();
  });

  /**** Prefix asset urls with the CDN if enabled ****/
  window.Edu.prefixCDN = function(path){
    if(!path) return '';
    if(window.CDNfail) return path;
    var is_absolute = (path.substring(0,7)==='http://' || path.substring(0,8)==='https://');

    // 1. if URL is relative and missing the leading slash, like "assets/something.png", prepend a leading slash
    if ( !is_absolute && path[0] !== '/' ){
      path = '/'+path;
    }

    // 2. check if CDN is enabled. if so:
    //    a. relative paths resolve to cdn+path
    //    b. http(s)://www.education.com+path resolves to cdn+path
    //    c. http(s)://other.domain is not modified
    if(window.Edu.cdn) {
      if (is_absolute) {
        if (path.substring(0, 24) === 'http://www.education.com') {
          path = window.Edu.cdn + path.substring(24);
        } else if (path.substring(0, 25) === 'https://www.education.com') {
          path = window.Edu.cdn + path.substring(25);
        }
      } else {
        path = window.Edu.cdn + path;
      }
    }

    return path;
  };

  /*!
   * jQuery Cookie Plugin v1.4.1
   * https://github.com/carhartl/jquery-cookie
   *
   * Copyright 2006, 2014 Klaus Hartl
   * Released under the MIT license
   */
  !function(e){"function"==typeof define&&define.amd?define(["jquery"],e):e("object"==typeof exports?require("jquery"):jQuery)}(function(e){function n(e){return u.raw?e:encodeURIComponent(e)}function o(e){return u.raw?e:decodeURIComponent(e)}function i(e){return n(u.json?JSON.stringify(e):String(e))}function r(e){0===e.indexOf('"')&&(e=e.slice(1,-1).replace(/\\"/g,'"').replace(/\\\\/g,"\\"));try{return e=decodeURIComponent(e.replace(c," ")),u.json?JSON.parse(e):e}catch(n){}}function t(n,o){var i=u.raw?n:r(n);return e.isFunction(o)?o(i):i}var c=/\+/g,u=e.cookie=function(r,c,a){if(arguments.length>1&&!e.isFunction(c)){if(a=e.extend({},u.defaults,a),"number"==typeof a.expires){var f=a.expires,s=a.expires=new Date;s.setTime(+s+864e5*f)}return document.cookie=[n(r),"=",i(c),a.expires?"; expires="+a.expires.toUTCString():"",a.path?"; path="+a.path:"",a.domain?"; domain="+a.domain:"",a.secure?"; secure":""].join("")}for(var d=r?void 0:{},p=document.cookie?document.cookie.split("; "):[],m=0,x=p.length;x>m;m++){var l=p[m].split("="),g=o(l.shift()),k=l.join("=");if(r&&r===g){d=t(k,c);break}r||void 0===(k=t(k))||(d[g]=k)}return d};u.defaults={},e.removeCookie=function(n,o){return void 0===e.cookie(n)?!1:(e.cookie(n,"",e.extend({},o,{expires:-1})),!e.cookie(n))}});

  $(document).ajaxSend(function(event, jqXHR, ajaxOptions) {
    if (window.jQuery.inArray(ajaxOptions.type.toLowerCase(), ['post','put','patch','delete']) !== -1 && ajaxOptions.url.substring(0,5).toLowerCase() === '/api/') {
      jqXHR.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      if (ajaxOptions.data && ajaxOptions.data.length) {
        ajaxOptions.data += '&'+window.jQuery.param({csrfToken: window.Edu.csrfToken});
      } else {
        ajaxOptions.data = window.jQuery.param({csrfToken: window.Edu.csrfToken});
      }
    }
  });

  /** Fix for when the session has expired */
  $(document).ajaxComplete(function(event, xhr, settings) {
    if (!('expiredSessionRefresh' in window.Edu.queryString)) {
      if (xhr && xhr.status === 403 && settings && settings.type === 'POST') {
        if ('expiredSessionRefresh' in xhr.responseJSON) {
          var refreshUrl = window.location.href;
          if (window.Edu.queryString.length) {
              refreshUrl += '&expiredSessionRefresh=true';
          } else {
              refreshUrl += '?expiredSessionRefresh=true';
          }
          window.location = refreshUrl;
        }
      }
    }
  });
})(window.jQuery||window.Zepto);
